/**
 * @deprecated
 * Created by juyang on 2017/9/20.
 */
'use strict';
define(['./Class'], function (Class) {


    var subControl = Class.extend({

        options: {
            el: undefined//根div
        },

        addTo: function (el) {
            this.options.el = el;
            this._container1 = this.onAdd(map);
            $(this.options.el).append($(this._container1))

        },
        remove: function () {
            this.onRemove();
            $(this._container1).remove();
        }


    })

    return subControl;
})